module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"NewBillingAddress":"Nuovo profilo di fatturazione","UpdateBillingAddress":"Aggiorna il tuo profilo di fatturazione","addBillingProfile_Header":"Dati di Fatturazione","NotActive":"Non attivo"},"en":{"NewBillingAddress":"Add billing information","UpdateBillingAddress":"Update billing information","addBillingProfile_Header":"Billing Information","NotActive":"Not active"}}')
  delete Component.options._Ctor
}
